import { ThunkAction } from 'redux-thunk';
import {ArticleAction, LOAD_PLAYER, SET_ERROR, SET_LOADING, SET_SUCCESS } from '../../constants/narrationConstants';
import { RootState } from '../..';
import loadPlyr from '../../../services/misc/plyrList';
/* Create user
export const signup = (data: SignUpData, onError: () => void): ThunkAction<void, RootState, null, ArticleAction> => {
  return async dispatch => {
    try {

    } catch (err) {
      console.log(err);
      onError();
      dispatch({
        type: SET_ERROR,
        payload: err.message
      });
    }
  }
}*/

// Set loading
export const setLoading = (value: boolean): ThunkAction<void, RootState, null, ArticleAction> => {
    return dispatch => {
        dispatch({
            type: SET_LOADING,
            payload: value
        });
    }
}


// Set error
export const setError = (msg: string): ThunkAction<void, RootState, null, ArticleAction> => {
    return dispatch => {
        dispatch({
            type: SET_ERROR,
            payload: msg
        });
    }
}


// Set success
export const setSuccess = (msg: string): ThunkAction<void, RootState, null, ArticleAction> => {
    return dispatch => {
        dispatch({
            type: SET_SUCCESS,
            payload: msg
        });
    }
}


// Get the Narration for the requested URL
export const requestNarration = (request_url: string, token: string): ThunkAction<void, RootState, null, ArticleAction> => {
    return async dispatch => {
        try {
            //dispatch(setLoading(true));
            // Production VS Local Dev API
            let api_url = "";
            if ( window.location.hostname === 'localhost') {
                const path = 'http://localhost:5001/nalij-api/us-central1/app/';
                api_url = path + '/api/narrate';
            } else {
                // production code
                api_url = '/api/narrate';
            }

            const response = await fetch(api_url, {
                method: 'post',
                headers: new Headers({
                    'auth-token': token
                }),
                body: JSON.stringify({url:request_url})
            });
            const data = await response.json();
            //dispatch(setLoading(false));

            dispatch({
                type: LOAD_PLAYER,
                payload: data
            });

            //const player = new Plyr('.plyr');
            loadPlyr();

        } catch (err) {
            console.log(err);
            dispatch(setError(err.message));
        }
    }
}
